import { render } from "./BaseHeader.vue?vue&type=template&id=596a88f4&scoped=true"
const script = {}

import "./BaseHeader.vue?vue&type=style&index=0&id=596a88f4&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596a88f4"]])

export default __exports__